import { ROLES } from 'src/constants/auth';
import { StockPhotoImportBatch } from 'src/redux/api/inventory/stockPhotoImports';

export const canImportVehicleStockPhotos = (user?: User): boolean =>
  !!user &&
  [
    ROLES.SUPER_ADMIN,
    ROLES.ADMIN,
    ROLES.APPADMIN,
    ROLES.MANAGER,
    ROLES.SELLER,
    ROLES.PHOTOGRAPHER,
  ].includes(user.role.id);

export const getAccountDisplayInfo = (batch: StockPhotoImportBatch) => ({
  title: batch.account?.name || '',
  thumbnail: batch.account?.avatar || undefined,
});

/**
 * Create and detail responses may omit `account`. Keep the summary we already have so the
 * toast title and avatar do not blank out on every poll.
 */
export const withPreservedAccount = (
  incoming: StockPhotoImportBatch,
  existing?: StockPhotoImportBatch | null,
): StockPhotoImportBatch =>
  incoming.account || !existing?.account ? incoming : { ...incoming, account: existing.account };
